module.exports = __webpack_public_path__ + "static/media/3-Y.adbfbab7.mp3";